/* ==========================================================================
   Ekka Order Popup — cart/sidecart checkout interception.
   Requires jQuery (already loaded globally) and Fancybox v3 (already loaded).

   Flow:
     1. On any checkout button click, if popup exists → intercept.
     2. Open popup. Pre-filled from Liquid-rendered customer metafields.
     3. On submit:
        a. If "Not an Ekka order" is ticked → clear any Ekka cart attributes
           and proceed to checkout.
        b. Else validate + POST 6 fields to /cart/update.js as attributes,
           then redirect to checkout with venue address query params so the
           Ekka $10 delivery rate is selected.
     4. Shopify Flow (configured in admin) then handles order tagging and
        syncing attributes back to customer metafields.
   ========================================================================== */

(function ($) {
  'use strict';

  // Only require jQuery up front. Fancybox is checked at click time because it
  // may load after this script due to defer ordering across vendor bundles.
  if (!$) return;

  var POPUP_SELECTOR = '#ekka-order-popup';
  var CHECKOUT_BUTTON_SELECTOR = '[data-cart-checkout-button], [data-minicart-checkout-button]';

  // Static Ekka venue address pre-filled on checkout for every Ekka order.
  // Stall-specific details (Location, Level, Row/Aisle #, Stable #) are kept
  // in the order's Additional Details (custom attributes) — Breanna reads them
  // from there when preparing the delivery. Not added to the shipping address.
  var EKKA_VENUE = {
    address1: 'EKKA DELIVERY - 600 Gregory Terrace (do not edit)',
    city: 'Bowen Hills',
    province: 'QLD',
    zip: '4006',
    country: 'AU'
  };

  var EKKA_FIELD_NAMES = [
    'Location',
    'Level',
    'Row/Aisle #',
    'Stable #',
    'Delivery Date',
    'Delivery Time Window'
  ];

  // Explicit marker — used by Shopify Flow to identify Ekka orders.
  var EKKA_MARKER_KEY = 'ekka_order';

  // sessionStorage key for auto-reopening the popup after a back-nav from
  // /checkout. No age cap — sessionStorage is already scoped to the tab, so
  // the flag clears when the tab closes.
  var RESUME_KEY = 'ekka_resume_popup';

  // Bypass flag — once the popup resolves, we submit the checkout programmatically
  // without re-triggering the interceptor.
  var bypassInterception = false;

  $(function () {
    var $popup = $(POPUP_SELECTOR);
    if ($popup.length === 0) return; // No popup = customer not tagged Ekka, nothing to do.

    filterDeliveryDateOptions($popup);
    bindCheckoutInterception();
    bindNotEkkaToggle($popup);
    bindFormSubmit();
    bindBfcacheReset();
    maybeResumePopup();
  });

  // -------------------------------------------------------------------------
  // Resume popup after back-nav from /checkout
  // -------------------------------------------------------------------------
  //
  // proceedToEkkaCheckout drops a timestamp into sessionStorage before
  // redirecting. When the customer hits back and the cart reloads (either
  // natively or via the bfcache-reset reload below), we check that flag:
  // if it's recent, auto-open the popup. hydrateFromCart then repopulates
  // the form from cart.attributes so their previous selections are intact.

  function maybeResumePopup() {
    var raw = safeSessionGet(RESUME_KEY);
    if (!raw) return;
    safeSessionRemove(RESUME_KEY);
    openPopup();
  }

  function markResumePopup() {
    safeSessionSet(RESUME_KEY, '1');
  }

  function safeSessionGet(key) {
    try { return sessionStorage.getItem(key); } catch (err) { return null; }
  }
  function safeSessionSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (err) {}
  }
  function safeSessionRemove(key) {
    try { sessionStorage.removeItem(key); } catch (err) {}
  }

  // -------------------------------------------------------------------------
  // bfcache reset
  // -------------------------------------------------------------------------
  //
  // Submit redirects to /checkout mid-Fancybox-open, so teardown never runs.
  // On back-nav, Safari in particular can fail to restore event listeners
  // cleanly from bfcache, leaving the popup visible but non-interactive.
  // Force a full reload on bfcache restore — the customer lands on a clean
  // cart page and re-clicks checkout; hydrateFromCart then pulls their
  // previous selections from cart.attributes, so nothing is lost.

  function bindBfcacheReset() {
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        window.location.reload();
      }
    });
  }

  function closeLingeringFancybox() {
    if (!$.fancybox) return;
    try {
      if (typeof $.fancybox.getInstance === 'function' && $.fancybox.getInstance()) {
        $.fancybox.close(true);
      } else if (typeof $.fancybox.close === 'function') {
        $.fancybox.close(true);
      }
    } catch (err) {
      console.error('[ekka] closeLingeringFancybox failed:', err);
    }
  }

  // -------------------------------------------------------------------------
  // Delivery date filtering
  // -------------------------------------------------------------------------
  //
  // The shop metafield `custom.delivery_dates` holds display strings like
  // "Saturday August 16th". We parse each one (assuming current year), then
  // remove any option earlier than the popup's data-min-date. data-min-date is
  // already computed in Liquid to be tomorrow, or day-after-tomorrow if the
  // current shop time is 3pm or later.
  //
  // If parsing fails for a given entry (unexpected format), we leave it alone
  // — better to show the option than to accidentally hide a valid date.

  function filterDeliveryDateOptions($popup) {
    var minDateStr = $popup.attr('data-min-date');
    if (!minDateStr) return;
    var minDate = new Date(minDateStr + 'T00:00:00');
    if (isNaN(minDate.getTime())) return;

    var $select = $popup.find('[data-ekka-form] [name="Delivery Date"]');
    $select.find('option').each(function () {
      var $opt = $(this);
      var label = $opt.attr('value');
      if (!label) return; // Skip the placeholder option.
      var parsed = parseDeliveryDateLabel(label);
      if (parsed && parsed < minDate) {
        $opt.remove();
      }
    });

    // If the pre-selected saved value was removed as stale, the <select> will
    // now show the placeholder — customer picks fresh, which is what we want.
  }

  function parseDeliveryDateLabel(label) {
    // Expected format: "Saturday August 16th". Strip the day-of-week prefix and
    // the ordinal suffix, assume current year, let Date() parse the rest.
    var cleaned = label.trim()
      .replace(/^[A-Za-z]+\s+/, '')          // drop "Saturday "
      .replace(/(\d+)(st|nd|rd|th)/i, '$1'); // drop "th" / "st" / "nd" / "rd"
    var year = new Date().getFullYear();
    var parsed = new Date(cleaned + ' ' + year);
    if (isNaN(parsed.getTime())) return null;
    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }

  // -------------------------------------------------------------------------
  // Checkout button interception
  // -------------------------------------------------------------------------

  function bindCheckoutInterception() {
    // Use native capture-phase listener so this runs BEFORE any jQuery-bound
    // handlers in the theme's cart JS (jquery.cart.min.js / shopacado.js),
    // which otherwise stopImmediatePropagation before our delegated handler fires.
    document.addEventListener('click', function (e) {
      if (bypassInterception) return;
      var target = e.target && e.target.closest
        ? e.target.closest('[data-cart-checkout-button], [data-minicart-checkout-button]')
        : null;
      if (!target) return;
      if (!window.jQuery || !window.jQuery.fancybox) {
        // Fancybox not loaded — let the form submit normally so we don't trap
        // the customer on the cart page.
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      openPopup();
    }, true); // true = capture phase
  }

  function openPopup() {
    if (!$.fancybox) return;
    // Close any lingering instance (e.g. from bfcache back-nav where we
    // redirected mid-open and never ran teardown) before reopening.
    closeLingeringFancybox();
    var $popup = $(POPUP_SELECTOR);
    hydrateFromCart($popup).always(function () {
      $.fancybox.open({
        src: POPUP_SELECTOR,
        type: 'inline',
        opts: {
          touch: false,
          smallBtn: false,
          modal: false
        }
      });
    });
  }

  // -------------------------------------------------------------------------
  // Hydrate form from cart.attributes
  // -------------------------------------------------------------------------
  //
  // Liquid pre-fills the form from customer.metafields (last-order snapshot).
  // Those metafields only update AFTER an order is placed (via Shopify Flow),
  // so if a customer edits values, hits checkout, then clicks back, the form
  // would otherwise re-render with the stale metafield values. cart.attributes
  // holds the in-progress values — we overlay them here so the latest selection
  // persists across back-nav.

  function hydrateFromCart($popup) {
    return $.getJSON('/cart.js').done(function (cart) {
      var attrs = (cart && cart.attributes) || {};
      EKKA_FIELD_NAMES.forEach(function (name) {
        var val = attrs[name];
        if (val == null || val === '') return;
        var $input = $popup.find('[name="' + cssEscape(name) + '"]');
        if ($input.length) $input.val(val);
      });
    }).fail(function (xhr, status, err) {
      console.error('[ekka] hydrateFromCart failed:', status, err);
    });
  }

  // -------------------------------------------------------------------------
  // "Not an Ekka order" checkbox — disables field grid visually + removes required
  // -------------------------------------------------------------------------

  function bindNotEkkaToggle($popup) {
    var $toggle = $popup.find('[data-ekka-not-ekka-toggle]');
    var $fields = $popup.find('[data-ekka-fields]');
    var $submit = $popup.find('[data-ekka-submit]');
    var $inputs = $fields.find('input, select');

    $toggle.on('change', function () {
      var notEkka = $(this).is(':checked');
      $fields.attr('data-disabled', notEkka ? 'true' : 'false');
      $inputs.each(function () {
        this.disabled = notEkka;
        if (notEkka) {
          $(this).data('was-required', this.required);
          this.required = false;
        } else {
          this.required = $(this).data('was-required') !== false;
        }
      });
      $submit.text(
        notEkka ? 'Continue to Checkout (Not Ekka)' : 'Confirm & Continue to Checkout'
      );
    });
  }

  // -------------------------------------------------------------------------
  // Form submit
  // -------------------------------------------------------------------------

  function bindFormSubmit() {
    // Delegate at document level so the handler survives Fancybox moving the
    // popup DOM into its overlay container. Also defends against theme-level
    // submit handlers (jquery.cart.min.js / shopacado.js) calling
    // stopImmediatePropagation on form elements further up the tree.
    $(document).on('submit', '#ekka-order-popup [data-ekka-form]', handleEkkaSubmit);

    // Belt-and-suspenders: if another handler swallows the native submit
    // event before it bubbles to our delegate, the click on the submit button
    // still routes us through the same flow.
    $(document).on('click', '#ekka-order-popup [data-ekka-submit]', function (e) {
      var $form = $(this).closest('[data-ekka-form]');
      if (!$form.length) return;
      e.preventDefault();
      $form.trigger('submit');
    });
  }

  function handleEkkaSubmit(e) {
    e.preventDefault();

    var $form = $(this);
    var $popup = $form.closest(POPUP_SELECTOR);
    var $submit = $form.find('[data-ekka-submit]');
    var $error = $form.find('[data-ekka-error]');
    var isNotEkka = $form.find('[data-ekka-not-ekka-toggle]').is(':checked');

    $error.hide().text('');
    $submit.prop('disabled', true);

    if (isNotEkka) {
      clearEkkaAttributes()
        .done(proceedToStandardCheckout)
        .fail(function (xhr, status, err) {
          console.error('[ekka] clearEkkaAttributes failed:', status, err, xhr);
          showError($error, 'Unable to update your cart. Please try again.');
          $submit.prop('disabled', false);
        });
      return;
    }

    var formData = collectFormData($form);
    var validationError = validateFormData(formData, $popup);
    if (validationError) {
      showError($error, validationError);
      $submit.prop('disabled', false);
      return;
    }

    writeEkkaAttributes(formData)
      .done(proceedToEkkaCheckout)
      .fail(function (xhr, status, err) {
        console.error('[ekka] writeEkkaAttributes failed:', status, err, xhr);
        showError($error, 'Unable to save your delivery details. Please try again.');
        $submit.prop('disabled', false);
      });
  }

  function collectFormData($form) {
    var data = {};
    EKKA_FIELD_NAMES.forEach(function (name) {
      var $input = $form.find('[name="' + cssEscape(name) + '"]');
      data[name] = ($input.val() || '').toString().trim();
    });
    return data;
  }

  function validateFormData(data, $popup) {
    for (var i = 0; i < EKKA_FIELD_NAMES.length; i++) {
      var name = EKKA_FIELD_NAMES[i];
      if (!data[name]) {
        return 'Please fill in the "' + name + '" field.';
      }
    }

    // Date must be >= min
    var minDate = $popup.attr('data-min-date');
    if (data['Delivery Date'] < minDate) {
      return 'Delivery Date must be ' + minDate + ' or later.';
    }

    return null;
  }

  // -------------------------------------------------------------------------
  // Cart attribute writes via /cart/update.js
  // -------------------------------------------------------------------------

  function writeEkkaAttributes(data) {
    var attributes = {};
    EKKA_FIELD_NAMES.forEach(function (name) {
      attributes[name] = data[name];
    });
    attributes[EKKA_MARKER_KEY] = 'true';
    return postCartUpdate({ attributes: attributes });
  }

  function clearEkkaAttributes() {
    var attributes = {};
    EKKA_FIELD_NAMES.forEach(function (name) {
      attributes[name] = ''; // Empty string removes the attribute.
    });
    attributes[EKKA_MARKER_KEY] = '';
    return postCartUpdate({ attributes: attributes });
  }

  function postCartUpdate(payload) {
    return $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(payload)
    });
  }

  // -------------------------------------------------------------------------
  // Redirect to checkout (with or without venue pre-fill)
  // -------------------------------------------------------------------------

  function proceedToEkkaCheckout() {
    markResumePopup();
    var params = [
      'checkout[shipping_address][address1]=' + encodeURIComponent(EKKA_VENUE.address1),
      'checkout[shipping_address][city]=' + encodeURIComponent(EKKA_VENUE.city),
      'checkout[shipping_address][province]=' + encodeURIComponent(EKKA_VENUE.province),
      'checkout[shipping_address][zip]=' + encodeURIComponent(EKKA_VENUE.zip),
      'checkout[shipping_address][country]=' + encodeURIComponent(EKKA_VENUE.country)
    ].join('&');
    window.location.href = '/checkout?' + params;
  }

  function proceedToStandardCheckout() {
    // Must explicitly overwrite any shipping address previously saved on the
    // checkout by proceedToEkkaCheckout — clearing cart.attributes alone
    // doesn't reset the address Shopify persists on the checkout record, so
    // /checkout would otherwise re-render with the Ekka venue still selected.
    // The Liquid side deliberately skips any saved address matching the Ekka
    // venue when picking which address to pre-fill; if the customer has no
    // non-Ekka address on file the fields are blank, which still overrides
    // the Ekka values.
    var $popup = $(POPUP_SELECTOR);
    var params = [
      'checkout[shipping_address][first_name]=' + encodeURIComponent($popup.attr('data-customer-first-name') || ''),
      'checkout[shipping_address][last_name]=' + encodeURIComponent($popup.attr('data-customer-last-name') || ''),
      'checkout[shipping_address][phone]=' + encodeURIComponent($popup.attr('data-customer-phone') || ''),
      'checkout[shipping_address][address1]=' + encodeURIComponent($popup.attr('data-customer-address1') || ''),
      'checkout[shipping_address][address2]=' + encodeURIComponent($popup.attr('data-customer-address2') || ''),
      'checkout[shipping_address][city]=' + encodeURIComponent($popup.attr('data-customer-city') || ''),
      'checkout[shipping_address][province]=' + encodeURIComponent($popup.attr('data-customer-province') || ''),
      'checkout[shipping_address][zip]=' + encodeURIComponent($popup.attr('data-customer-zip') || ''),
      'checkout[shipping_address][country]=' + encodeURIComponent($popup.attr('data-customer-country') || '')
    ].join('&');
    window.location.href = '/checkout?' + params;
  }

  // -------------------------------------------------------------------------
  // Helpers
  // -------------------------------------------------------------------------

  function showError($el, message) {
    $el.text(message).show();
  }

  // jQuery selector-safe escape for attribute values with `/`, `#`, spaces.
  function cssEscape(value) {
    return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~\s])/g, '\\$1');
  }
})(window.jQuery);
